import React from 'react';
import './Video.css';

const Video = () => {

  return (
    <div className="video-wall">
      
      {/* CONTENITORE VIDEO CON EFFETTO NEON (Senza testo sopra) */}
      <div className="video-container">
        <iframe
          width="100%"
          height="100%"
          src="https://www.youtube.com/embed/lv01pM2w0wE?autoplay=1&mute=1&loop=1&playlist=lv01pM2w0wE&controls=1&modestbranding=1&rel=0"
          title="Soul Rock Museum Restaurant - Ghostbusters Ecto-1"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>

      {/* STILI SPECIFICI PER LA PAGINA VIDEO */}
      <style>{`
        .video-container {
          max-width: 450px;
          width: 100%;
          margin: 0 auto;
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 0 30px rgba(240, 124, 0, 0.3);
          border: 1px solid rgba(240, 124, 0, 0.2);
          transition: box-shadow 0.3s ease;
          background: #000;
          aspect-ratio: 9 / 16;
        }

        .video-container:hover {
          box-shadow: 0 0 50px rgba(240, 124, 0, 0.5);
        }
      `}</style>
    </div>
  );
};

export default Video;